import { render, staticRenderFns } from "./Ruten.vue?vue&type=template&id=a0d6c05a&"
import script from "./Ruten.vue?vue&type=script&lang=js&"
export * from "./Ruten.vue?vue&type=script&lang=js&"
import style0 from "./Ruten.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports